import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { API as ApiConstant }      from '../api/api.constant';
import { ApiService }              from '../api/api.service';
import { CompanyService }          from '../companies/company.service';
import { ConfirmService }          from '../messages/confirm/confirm.service';
import { MessagesService }         from '../messages/messages.service';
import { SessionService }          from '../sessions/session.service';
import { StreamSearchService }     from '../api/stream-search.service';

import { CompanyMessagesModel }    from '../companies/models/company.messages';
import { CustomerModel }           from '../customers/models/customer';
import { InvoiceModel }            from '../invoices/models/invoice';
import { LoanCarModel }            from './typings/loan-car';
import { LoanCarVehicleModel }     from './typings/loan-car.vehicle';
import { SelectOption }            from '../core/models/select-option';
import { SessionCompanyModel }     from '../sessions/models/session.company';

@Component({
  selector: 'wor-loan-car-start',
  template: `
    <wor-flipper [side]="activeSide">
      <div front>
        <div class="modal-header bg-info title d-flex align-items-center">
          <h1>
            <i class="fa fa-tag"></i>
            {{ 'LOAN_CAR_SPACE.START_LOAN_CAR' | translate }}
            - {{ loanVehicle?.plate_number }} - {{ loanVehicle?.make }} {{ loanVehicle?.model }} {{ loanVehicle?.model_code }} {{ loanVehicle?.model_series }} - {{ loanVehicle?.build_date }} {{ loanVehicle?.colour }}
          </h1>
        </div>
        <form #startForm="ngForm" class="form-horizontal" novalidate>
          <div class="modal-body">
            <div class="row">
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LOAN_NUMBER">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="loan_number"
                    [(ngModel)]="loanCar.loan_number"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LOAN_DATE">
                </label>
                <div class="input-group controls">
                  <input type="text" class="form-control"
                    name="loan_date"
                    [(ngModel)]="loanCar.loan_date"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LOAN_STATUS">
                </label>
                <div class="controls">
                  <select class="form-control"
                    name="loan_status"
                    [(ngModel)]="loanCar.loan_status"
                    disabled>
                    <option *ngFor="let t of loanStatusTypes"
                      [ngValue]="t.code">
                      {{ t.language_label | translate }}
                    </option>
                  </select>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-6">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.FIRST_NAME">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="first_name" maxlength="50"
                    [(ngModel)]="loanCar.contact_first_name"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-6">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.LAST_NAME">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="last_name" maxlength="50"
                    [(ngModel)]="loanCar.contact_last_name"
                    readonly>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-6"
                *ngIf="!companyService.country('newZealand')">
                <label class="control-label"
                  [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
                  [translateParams]="{ num: 1 }">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="address1" maxlength="50"
                    [(ngModel)]="loanCar.contact_address1"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-6"
                *ngIf="companyService.country('newZealand')">
                <label class="control-label"
                  [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
                  [translateParams]="{ num: 1 }">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="address1_nz"
                    [(ngModel)]="loanCar.contact_address1"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-6">
                <label class="control-label"
                  [translate]="'GENERAL_SPACE.FIELD.ADDRESS'"
                  [translateParams]="{ num: 2 }">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="address2" maxlength="50"
                    [(ngModel)]="loanCar.contact_address2"
                    readonly>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.SUBURB">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="suburb" maxlength="30"
                    [(ngModel)]="loanCar.contact_suburb"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  [translate]="companyService.country('unitedKingdom') ? 'GENERAL_SPACE.FIELD.COUNTY' : 'GENERAL_SPACE.FIELD.STATE'">
                </label>
                <div class="controls">
                  <select class="form-control"
                    name="state"
                    [(ngModel)]="loanCar.contact_state"
                    disabled>
                    <option *ngFor="let s of states"
                      [ngValue]="s.code">
                      {{ s.language_label | translate }}
                    </option>
                  </select>
                </div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.POSTCODE">
                </label>
                <div class="form-control disabled">{{ loanCar.contact_postcode }}</div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.PHONE_NUMBER">
                </label>
                <div class="form-control disabled">{{ loanCar.contact_phone }}</div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.MOBILE">
                </label>
                <div class="form-control disabled">{{ loanCar.contact_mobile }}</div>
              </fieldset>
              <fieldset class="col-md-4">
                <label class="control-label"
                  translate="GENERAL_SPACE.FIELD.EMAIL">
                </label>
                <div class="controls">
                  <div class="input-group">
                    <input type="text" class="form-control"
                      name="email" maxlength="60"
                      [(ngModel)]="loanCar.contact_email"
                      readonly>
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info"
                        disabled>
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="SERVICE_REMINDERS_SPACE.START_DATE">
                </label>
                <div class="input-group controls">
                  <input type="text" class="form-control readonly-disguise"
                    name="start_date"
                    [(ngModel)]="serviceInstance.loanCar.start_date"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="BOOKING_SPACE.START_TIME">
                </label>
                <div class="input-group controls">
                  <input type="text" class="form-control readonly-disguise"
                    name="start_time"
                    [(ngModel)]="serviceInstance.loanCar.start_time"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.RETURN_DATE">
                </label>
                <div class="input-group controls">
                  <input type="text" class="form-control readonly-disguise"
                    name="return_date"
                    [(ngModel)]="serviceInstance.loanCar.return_date"
                    readonly>
                </div>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.RETURN_TIME">
                </label>
                <div class="input-group controls">
                  <input type="text" class="form-control readonly-disguise"
                    name="return_time"
                    [(ngModel)]="serviceInstance.loanCar.return_time"
                    readonly>
                </div>
              </fieldset>
            </div>
            <div class="row" *ngIf="!loanCar.loan_vehicle_id">
              <fieldset class="col-sm-6">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.SEARCH_LOAN_VEHICLES">
                </label>
                <div class="controls autocomplete">
                  <input type="text" class="form-control"
                    name="loan_vehicle_search"
                    [placeholder]="'LOAN_CAR_SPACE.CHOOSE_AVAILABLE_LOAN_VEHICLE' | translate"
                    [worTypeahead]="loanVehicleSearch"
                    [(ngModel)]="loanVehicleSearch.value"
                    [readonly]="loanCar.loan_status !== 'P'">
                </div>
              </fieldset>
            </div>
            <div class="row">
              <hr>
            </div>
            <div class="row">
              <fieldset class="top-buffer">
                <label translate="LOAN_CAR_SPACE.LICENSE_DETAILS"></label>
              </fieldset>
              <fieldset class="col-md-6">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LICENSE_NUMBER">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="license_number" maxlength="50"
                    [(ngModel)]="loanCar.license_number"
                    [readonly]="loanCar.loan_status !== 'P'">
                </div>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LICENSE_EXPIRY_DATE">
                </label>
                <wor-date-control
                  name="license_expiry"
                  [(ngModel)]="loanCar.license_expiry"
                  [readonly]="loanCar.loan_status !== 'P'">
                </wor-date-control>
              </fieldset>
            </div>
            <div class="row" *ngIf="loanCar.loan_vehicle_id">
              <fieldset class="top-buffer">
                <label translate="LOAN_CAR_SPACE.VEHICLE_CHECK"></label>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="VEHICLE_SPACE.ODOMETER">
                </label>
                <div class="controls">
                  <input type="text" class="form-control"
                    name="odometer_before"
                    number [min]="0" [max]="10000000"
                    [(ngModel)]="loanCar.odometer_before"
                    [readonly]="loanCar.loan_status !== 'P'">
                </div>
              </fieldset>
              <fieldset class="col-md-3">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.FUEL_LEVEL">
                </label>
                <div class="controls input-group">
                  <input type="text" class="form-control"
                    name="fuel_level_before"
                    number [min]="0" [max]="100"
                    [(ngModel)]="loanCar.fuel_level_before"
                    [readonly]="loanCar.loan_status !== 'P'">
                  <span class="input-group-addon">
                    <span class="symbol">%</span>
                  </span>
                </div>
              </fieldset>
              <fieldset class="col-md-2">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LOAN_VEHICLE_CLEAN">
                </label>
                <label class="switch switch-success">
                  <input type="checkbox" class="switch-input"
                    name="clean_before"
                    [(ngModel)]="loanCar.loan_vehicle_clean_before"
                    [disabled]="loanCar.loan_status !== 'P'">
                  <span class="switch-label"
                    [attr.data-off]="'GENERAL_SPACE.SWITCH.NO' | translate"
                    [attr.data-on]="'GENERAL_SPACE.SWITCH.YES' | translate">
                  </span>
                  <span class="switch-handle"></span>
                </label>
              </fieldset>
              <fieldset class="col-sm-4">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.CHECKED_BY">
                </label>
                <div class="autocomplete autocomplete--contain">
                  <input type="text" class="form-control"
                    name="service_adviser" id="service_adviser"
                    [worTypeahead]="serviceAdviserSearch"
                    [(ngModel)]="serviceAdviserSearch.value"
                    [readonly]="loanCar.loan_status !== 'P'">
                </div>
              </fieldset>
            </div>
            <div class="row">
              <fieldset class="col-md-12">
                <label class="control-label"
                  translate="LOAN_CAR_SPACE.LOAN_CAR_NOTE">
                </label>
                <textarea name="note_before" type="text"
                  [(ngModel)]="loanCar.note_before" rows="6"
                  [readonly]="loanCar.loan_status !== 'P'">
                </textarea>
              </fieldset>
            </div>
          </div>
          <div class="modal-footer d-flex align-items-center">
            <button type="button" class="btn btn-default"
              (click)="modal.dismiss()"
              translate="GENERAL_SPACE.BUTTON.CANCEL">
            </button>
            <button type="button" class="btn btn-danger"
              *ngIf="loanCar?.id && (loanCar.loan_status === 'P' || loanCar.loan_status === 'A')"
              (click)="cancelLoanRequest()"
              translate="LOAN_CAR_SPACE.CANCEL_LOAN_REQUEST">
            </button>
            <div class="d-flex align-items-center m-left-auto">
              <button type="button" class="btn btn-success"
                *ngIf="loanCar?.id && loanCar.loan_status === 'P'"
                (click)="modifyLoan()"
                translate="LOAN_CAR_SPACE.MODIFY_LOAN">
              </button>
              <button type="button" class="btn btn-primary"
                (click)="flipToTerms()"
                translate="GENERAL_SPACE.BUTTON.CONTINUE">
              </button>
            </div>
          </div>
        </form>
      </div>
      <div back>
        <div class="modal-header bg-info title d-flex align-items-center">
          <h1>
            <i class="fa fa-tag"></i>
            {{ 'LOAN_CAR_SPACE.LOAN_CAR_TERMS_AND_CONDITIONS' | translate }}
          </h1>
        </div>
        <form class="form-horizontal" novalidate>
          <div class="modal-body">
            <div>
              <label class="control-label"
                translate="LOAN_CAR_SPACE.TERMS_AND_CONDITIONS">
              </label>
              <div class="well"
                [innerHTML]="companyMessages?.loan_terms_and_conditions_message">
              </div>
            </div>
            <div class="d-flex flex-direction-column">
              <label class="control-label"
                translate="LOAN_CAR_SPACE.TERMS_AND_CONDITIONS_CONFIRM">
              </label>
              <label class="switch switch-success">
                <input type="checkbox" class="switch-input"
                  name="terms_agreed_to_by_customer"
                  [(ngModel)]="loanCar.terms_agreed_to_by_customer"
                  [disabled]="loanCar.loan_status !== 'P'">
                <span class="switch-label"
                  [attr.data-off]="'GENERAL_SPACE.SWITCH.NO' | translate"
                  [attr.data-on]="'GENERAL_SPACE.SWITCH.YES' | translate">
                </span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
          <div class="modal-footer d-flex align-items-center">
            <button type="button" class="btn btn-default"
              (click)="modal.dismiss()"
              translate="GENERAL_SPACE.BUTTON.CANCEL">
            </button>
            <button type="button" class="btn btn-danger"
              *ngIf="loanCar?.id && (loanCar.loan_status === 'P' || loanCar.loan_status === 'A')"
              (click)="cancelLoanRequest()"
              translate="LOAN_CAR_SPACE.CANCEL_LOAN_REQUEST">
            </button>
            <div class="d-flex align-items-center m-left-auto">
              <button type="button" class="btn btn-primary"
                (click)="returnToDetails()"
                translate="LOAN_CAR_SPACE.RETURN_TO_DETAILS">
              </button>
              <button type="button" class="btn btn-warning"
                *ngIf="loanCar?.id && loanCar.loan_status !== 'X'"
                (click)="printAuthorisation()"
                translate="LOAN_CAR_SPACE.PRINT_AUTHORISATION">
              </button>
              <button type="button" class="btn btn-success"
                *ngIf="loanCar?.id && loanCar.loan_status === 'P'"
                (click)="startLoan()"
                translate="LOAN_CAR_SPACE.CONFIRM_LOAN">
              </button>
            </div>
          </div>
        </form>
      </div>
    </wor-flipper>
  `
})
export class LoanCarStartComponent implements OnInit {
  @Input() loanCar         : LoanCarModel;
  @Input() loanVehicle     : LoanCarVehicleModel;
  @Input() customer        : CustomerModel;
  @Input() event           : { id?: string; event_number?: string };
  @Input() invoice         : InvoiceModel;
  @Input() loanStatusTypes : SelectOption[] = [];
  @Input() states          : SelectOption[] = [];
  @Input() company         : SessionCompanyModel;
  @Input() companyMessages : CompanyMessagesModel;
  @Input() serviceAdviser  : { id?: string; display_name?: string };
  @Input() serviceInstance : { loanCar: LoanCarModel; save: () => Promise<LoanCarModel>; modifyLoan: () => void };

  activeSide: 'front' | 'back' = 'front';
  loanVehicleSearch    : Record<string, unknown>;
  serviceAdviserSearch : Record<string, unknown>;

  constructor (
    public  modal               : NgbActiveModal,
    public  companyService      : CompanyService,
    private apiService          : ApiService,
    private confirmService      : ConfirmService,
    private messagesService     : MessagesService,
    private router              : UIRouter,
    private sessionService      : SessionService,
    private streamSearchService : StreamSearchService,
    private translateService    : TranslateService
  ) {}

  ngOnInit (): void {
    this.loanVehicleSearch = {
      value : this.loanVehicle?.plate_number || '',
      query : (typed: string) => this.streamSearchService.search('loan_vehicles', typed),
      format: (vehicle: LoanCarVehicleModel) => vehicle ? vehicle.plate_number : '',
      choose: (vehicle: LoanCarVehicleModel) => {
        this.loanVehicle = vehicle;
        this.loanCar.loan_vehicle_id = vehicle.id;
      }
    };

    this.serviceAdviserSearch = {
      value : this.serviceAdviser?.display_name || '',
      query : (typed: string) => this.apiService.get('/service_advisers/list', [typed, 0, '*']),
      format: (adviser: { display_name?: string }) => adviser ? adviser.display_name : '',
      choose: (adviser: { id?: string; display_name?: string }) => {
        this.serviceAdviser = adviser;
        this.loanCar.confirmed_by_before = adviser.id;
      }
    };
  }

  flipToTerms (): void {
    this.activeSide = 'back';
  }

  returnToDetails (): void {
    this.activeSide = 'front';
  }

  modifyLoan (): void {
    this.serviceInstance.save().then(() => {
      this.modal.close();
    }).then(() => {
      this.serviceInstance.modifyLoan();
    }).catch((err: unknown) => this.messagesService.error(err));
  }

  printAuthorisation (): void {
    this.serviceInstance.save().then(() => {
      window.open(`${ApiConstant.url}/reports/jasper_loan_car_authorisation/${this.serviceInstance.loanCar.id}.pdf`);
    });
  }

  startLoan (): void {
    this.serviceInstance.save().then(() => {
      return this.apiService.get('/loan_car/start_loan_car', this.serviceInstance.loanCar.id);
    }).then(() => {
      this.modal.close();
      this.messagesService.show(
        this.translateService.instant('LOAN_CAR_SPACE.LOAN_CAR_STARTED'),
        'success'
      );
    }).catch((err: unknown) => this.messagesService.error(err));
  }

  cancelLoanRequest (): void {
    this.confirmService.generic(
      this.translateService.instant('LOAN_CAR_SPACE.CANCEL_LOAN_CAR_REQUEST')
    ).then(() => {
      return this.apiService.get('/loan_car/cancel_loan_car_request', this.loanCar.id);
    }).then(() => {
      this.modal.close();
      this.messagesService.show(
        this.translateService.instant('LOAN_CAR_SPACE.LOAN_CAR_REQUEST_CANCELLED'),
        'success'
      );
    }).catch((err: unknown) => this.messagesService.error(err));
  }

  deleteLoan (): void {
    this.confirmService.generic(
      this.translateService.instant('LOAN_CAR_SPACE.DELETE_LOAN_CAR')
    ).then(() => {
      return this.apiService.delete('/loan_car', this.loanCar.id);
    }).then(() => {
      this.modal.close();
      this.messagesService.show(
        this.translateService.instant('LOAN_CAR_SPACE.LOAN_CAR_DELETED'),
        'success'
      );
      this.router.stateService.go('app.loan-car');
    }).catch((err: unknown) => this.messagesService.error(err));
  }
}
